import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { ServiceIcon, PillarIcon, IndustryIcon, IconCheck, IconArrow, IconDownload, IconHeart, IconLeaf } from "./Icons";
import { getServices, getWhyChooseUs, getIndustries, getCompliance, getApproach } from "../lib/api";

/* ---------- Services grid (cards link to detail) ---------- */
export const ServicesGrid = () => {
  const [services, setServices] = useState([]);
  useEffect(() => { getServices().then(setServices).catch(() => {}); }, []);
  return (
    <div className="svc-grid" data-testid="services-grid">
      {services.map((s, i) => (
        <Reveal key={s.id} delay={(i % 3) * 60}>
          <Link to={`/services/${s.slug}`} className="svc" data-testid={`service-card-${s.slug}`} style={{ height: "100%" }}>
            <span className="num">{s.number}</span>
            <div className="ic"><ServiceIcon name={s.icon} /></div>
            <h3>{s.title}</h3>
            <p>{s.summary}</p>
            <span className="more">Learn more <IconArrow /></span>
          </Link>
        </Reveal>
      ))}
    </div>
  );
};

/* ---------- Pillars (why lemur quality) ---------- */
export const PillarsSection = () => {
  const [pillars, setPillars] = useState([]);
  useEffect(() => { getWhyChooseUs().then(setPillars).catch(() => {}); }, []);
  return (
    <div className="pillars" data-testid="pillars" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))" }}>
      {pillars.map((p, i) => (
        <Reveal key={p.id} className="pillar" delay={(i % 4) * 60} data-testid={`pillar-${p.icon}`}>
          <div className="pic"><PillarIcon name={p.icon} /></div>
          <h3>{p.title}</h3>
          <p>{p.description}</p>
        </Reveal>
      ))}
    </div>
  );
};

/* ---------- Industries grid (cards link to detail) ---------- */
export const IndustriesGrid = () => {
  const [industries, setIndustries] = useState([]);
  useEffect(() => { getIndustries().then(setIndustries).catch(() => {}); }, []);
  return (
    <div className="hub-grid" data-testid="industries-grid">
      {industries.map((ind, i) => (
        <Reveal key={ind.id} delay={(i % 2) * 70}>
          <Link to={`/industries/${ind.slug}`} className="hub-card" data-testid={`industry-card-${ind.slug}`}>
            <span className="hc-num">{ind.number}</span>
            <div className="hc-ic"><IndustryIcon name={ind.icon} /></div>
            <h3>{ind.title}</h3>
            <p>{ind.summary}</p>
            <span className="more">Explore sector <IconArrow /></span>
          </Link>
        </Reveal>
      ))}
    </div>
  );
};

/* ---------- Compliance preview (healthcare + livestock) ---------- */
export const CompliancePreview = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { getCompliance().then((d) => setItems(d.filter((c) => ["healthcare", "livestock"].includes(c.slug)))).catch(() => {}); }, []);
  return (
    <div className="consult-grid" data-testid="compliance-preview">
      {items.map((c, i) => (
        <Reveal key={c.id} delay={i * 80}>
          <Link to={`/compliance/${c.slug}`} className={`cc ${c.practice}`} data-testid={`compliance-card-${c.slug}`} style={{ display: "block" }}>
            <span className="tag">
              {c.practice === "healthcare" ? <IconHeart stroke="#e11d3c" /> : <IconLeaf stroke="#c9760c" />} {c.tag}
            </span>
            <h3>{c.title}</h3>
            <p>{c.hero_lead}</p>
            <ul>
              {c.items.slice(0, 4).map((it) => (
                <li key={it.title}><IconCheck stroke="#e11d3c" /> {it.title}</li>
              ))}
            </ul>
            <span className="more" style={{ marginTop: 18, display: "inline-flex", alignItems: "center", gap: 6, fontFamily: "'Space Grotesk'", fontWeight: 600, fontSize: ".88rem", color: "var(--crimson)" }}>
              Learn more <IconArrow style={{ width: 15, height: 15 }} />
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
  );
};

/* ---------- Approach steps ---------- */
export const ApproachSteps = () => {
  const [steps, setSteps] = useState([]);
  useEffect(() => { getApproach().then(setSteps).catch(() => {}); }, []);
  return (
    <div className="steps" data-testid="approach-steps">
      {steps.map((s, i) => (
        <Reveal key={s.id} className="step" delay={(i % 4) * 60} data-testid={`step-${s.number}`}>
          <div className="sn">{s.number}</div>
          <h3>{s.title}</h3>
          <p>{s.description}</p>
        </Reveal>
      ))}
    </div>
  );
};

/* DownloadProfileButton removed per client directive (company profile no longer offered publicly) */
